import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=c854661a"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports